export default __webpack_public_path__ + "static/canada-37686e1828f35710989fda939db53216.jpg";